import type { SkinId } from '@/features/game/components/board/skins/types';
import type {
  SkinComponentType,
  SkinMetadata
} from '@/features/game/components/board/skins/metadata';
import { useTranslation } from 'react-i18next';
import { createResponsiveTextStroke } from '@/styles/textStroke';
import { SkinCard } from './SkinCard';

interface SkinSectionProps {
  componentType: SkinComponentType;
  labelKey: string;
  availableSkins: SkinMetadata[];
  selectedSkinId: SkinId;
  onSelect: (componentType: SkinComponentType, skinId: SkinId) => void;
  onStartTrial?: (componentType: SkinComponentType, skinId: SkinId) => void;
  onOpenShop?: () => void;
  isOwned?: (skinId: SkinId) => boolean;
  isTrialed?: (skinId: SkinId) => boolean;
  isLoading?: boolean;
}

export function SkinSection({
  componentType,
  labelKey,
  availableSkins,
  selectedSkinId,
  onSelect,
  onStartTrial,
  onOpenShop,
  isOwned,
  isTrialed,
  isLoading
}: SkinSectionProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2">
      <span
        className="font-mind-boggle text-white text-xl leading-none"
        style={createResponsiveTextStroke(0.8, 0.04)}
      >
        {t(labelKey as never)}
      </span>
      <div className="grid grid-cols-5 gap-2 px-3">
        {availableSkins.map((skin) => (
          <SkinCard
            key={skin.id}
            skin={skin}
            componentType={componentType}
            isSelected={skin.id === selectedSkinId}
            onSelect={onSelect}
            onStartTrial={onStartTrial}
            onOpenShop={onOpenShop}
            isOwned={isOwned?.(skin.id) ?? true}
            isTrialed={isTrialed?.(skin.id) ?? false}
            isLoading={isLoading}
          />
        ))}
      </div>
    </div>
  );
}
